import BaseService from './base'

export default class GroupService extends BaseService {
  static resource() {
    return 'api/v1/roles'
  }
}
